import React, {useState} from 'react';

import {hooks} from '../hooks';
import {SonsType} from '../types';
import {components} from '../components';

export const DetailSonsRaport: React.FC = () => {
  const navigate = hooks.useNavigate();
  const dispatch = hooks.useDispatch();
  const location = hooks.useLocation();

  const son: SonsType = location.state.son;

  const [opacity, setOpacity] = useState<number>(0);

  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        showGoBack={true}
        showBasket={true}
        title='Child Raport'
      />
    );
  };

  const renderDetails = (): JSX.Element => {
    return (
      <section style={{display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', marginTop: 10, paddingTop: 8, paddingBottom: 40, gap: 15}}>
          <span onClick={() => navigate(`/detail-sons/detail-sons-absensi/${son.id}`, {state: {son}})}>
            <img style={{maxWidth: 50, padding: 10, borderRadius: 6, border: '1px solid var(--border-color)', backgroundColor: 'var(--main-turquoise)'}} className='clickable' src="/assets/img-icon/absensi-icon-white.png" alt="Absensi Icon" />
            <p className='t10' style={{textAlign: 'center'}}>Absensi</p>
          </span>
          <span onClick={() => navigate(`/detail-sons/detail-sons-rkh/${son.id}`, {state: {son}})}>
            <img style={{maxWidth: 50, padding: 10, borderRadius: 6, border: '1px solid var(--border-color)', backgroundColor: 'var(--main-turquoise)'}} className='clickable' src="/assets/img-icon/rkh-icon-white.png" alt="RKH Icon" />
            <p className='t10' style={{textAlign: 'center'}}>RKH</p>
          </span>
          <span onClick={() => navigate(`/detail-sons/detail-sons-subjects/${son.id}`, {state: {son}})}>
            <img style={{maxWidth: 50, padding: 10, borderRadius: 6, border: '1px solid var(--border-color)', backgroundColor: 'var(--main-turquoise)'}} className='clickable' src="/assets/img-icon/study-icon-white.png" alt="Study Icon" />
            <p className='t10' style={{textAlign: 'center'}}>Subjects</p>
          </span>
      </section>
    );
  };

  const renderImage = (): JSX.Element => {
    return (
      <section style={{position: 'relative'}}>
        <img
          src={son.banner}
          alt={son.name}
          style={{
            width: '100%', 
            borderRadius: 6,
            objectFit: 'cover',
            maxHeight: 260,
            objectPosition: 'top center'
          }}
        />
      </section>
    );
  };

  const renderRaport = (): JSX.Element => {
    return (
      <section>
        {/* <h4 style={{marginBottom: 10}}>Subjects</h4> */}
        <ul>
          {son.report.map((report) => (
            <li key={report.id} style={{minWidth: 140, padding: "20px 15px", borderBottom: '1px solid var(--border-color)'}}>
              <div style={{marginBottom: 15}}>
                {/* <p className='t12' style={{marginBottom: 15}}>{report.subtitle}</p> */}
                <h4 
                  className='t16'
                  style={{
                    padding: '0 10px',
                    borderRadius: 6,
                    backgroundColor: 'white',
                    border: '1px solid var(--main-turquoise)',
                    color: 'var(--main-turquoise)',
                  }}
                >{report.title}</h4>
              </div>
              <ul>
                {report.subjects?.map((item, index) => (
                  <li
                    key={item.id}
                    className={index % 2 === 0 ? 'bg-white' : 'bg-green-secondary'}
                    style={{
                      padding: 10,
                    }}
                  >
                    <div className='row-center-space-between'>
                      <p className='t12'>{item.title}</p>
                      <p className='t10'>{item.score}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </li>
          ))}
          {son.extracurricular.map((extra) => (
            <li key={extra.id} style={{minWidth: 140, padding: "20px 15px", borderBottom: '1px solid var(--border-color)'}}>
              <div style={{marginBottom: 15}}>
                <h4 
                  className='t16'
                  style={{
                    padding: '0 10px',
                    borderRadius: 6,
                    backgroundColor: 'white',
                    border: '1px solid var(--main-turquoise)',
                    color: 'var(--main-turquoise)',
                  }}
                >{extra.title}</h4>
              </div>
              <ul>
                {extra.subjects?.map((item, index) => (
                  <li
                    key={item.id}
                    className={index % 2 === 0 ? 'bg-white' : 'bg-green-secondary'}
                    style={{
                      padding: 10,
                    }}
                  >
                    <div className='row-center-space-between'>
                      <p className='t12'>{item.title}</p>
                      <p className='t10'>{item.score}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
        <div className='row-center-space-between' style={{marginBottom: 15, padding: '20px 15px'}}> 
          <h4>Final Score</h4>
          <p className='t12' style={{border: '1px solid var(--main-turquoise)', borderRadius: 6, padding: '5px 10px'}}>{son.final_score}</p>
        </div>
      </section>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <main className='scrollable container'>
        <ul style={{paddingTop: 10, paddingBottom: 20}}>
          <li
           style={{
            padding: '0 12px',
            borderRadius: 10,
            position: 'relative',
            marginBottom: 15,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 16,
          }}>
            <div
              style={{
                width: '100%',
              }}
            >
              <section style={{minWidth: 140, marginBottom: 15, borderRadius: 6, position: 'relative'}}>
                <div 
                  className='row-center-space-between' 
                  style={{
                    padding: 10, 
                    background: 'linear-gradient(180deg,rgba(255, 255, 255, 0) 50%, rgba(157, 160, 153, 0.4) 75%, rgba(45, 51, 37, 0.8) 100%)',
                    borderRadius: 6, 
                    position: 'absolute',
                    zIndex: 1,
                    width: '100%',
                    height: '100%',
                    alignItems: 'flex-end',
                    color: 'var(--main-turquoise)'
                  }}>
                  <h4 style={{color: 'white'}}>{son.name}</h4>
                  <span 
                    onClick={() => navigate(`/detail-sons/detail-sons-grade-analysis/${son.id}`, {state: {son}})} 
                    style={{width:'100%', maxWidth: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 6, backgroundColor: 'var(--main-turquoise)'}}>
                    <img style={{width: 38, padding: '7px 10px 7px 0'}}  className='clickable' src="/assets/img-icon/chart-white.png" alt="chart Icon"/>
                    <p className='t10' style={{textAlign: 'center', color: 'white', lineHeight: 1.2}}>Grade <br /> Analysis</p>
                  </span>
                </div>
                {renderImage()}
              </section>
              <components.BlockHeading
                title='Child Raport'
                containerStyle={{marginTop: 20, borderBottom: '1px solid var(--border-color)', paddingBottom: 5}}
              />
              {renderRaport()}
              {renderDetails()}
            </div>
          </li>
        </ul>
      </main>
    );
  };

  const renderFooter = (): JSX.Element => {
    return <components.Footer />;
  };

  return (
    <div
      id='screen'
      style={{opacity}}
    >
      {renderHeader()}
      {renderContent()}
      {renderFooter()}
    </div>
  );
};
